module.exports = __webpack_public_path__ + "img/Normal_OVERRPM.b5a928f5.png";